import { Component, Input } from '@angular/core';

import { HorseParticipantData } from '@cds/betting-offer/domain-specific/horse-racing/timeform';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { WinGameParticipant } from '@frontend/sports/racing/feature/models';

@Component({
    selector: 'ms-horse-info-header',
    templateUrl: 'horse-info-header.component.html',
    standalone: false,
})
export class HorseInfoHeaderComponent {
    @Input() participant: WinGameParticipant;
    @Input() participantInfo?: HorseParticipantData;

    constructor(public sitecore: Sitecore) {}
}
